import { assertUnreachable } from "@fidget/common/utils/ts-utils";
import React from "react";
import { Button, Postback } from "../../RichMessageTypes";
import { TextButtonContent } from "./textButton/TextButtonContent";
import { UrlButtonContent } from "./urlButton/UrlButtonContent";
import { userActions } from "../../../../../actions/user";
import { useForeContext } from "../../../../../models";
import style from "./ButtonContent.css";

export enum ButtonsStyleType {
  CHAT_BUTTONS = "chat-buttons",
  CAROUSEL = "carousel"
}

interface Props {
  buttons: Button[];
  buttonsStyle: ButtonsStyleType;
  disableTextButtons?: boolean;
}

export const ButtonContent = ({ buttons, buttonsStyle, disableTextButtons }: Props) => {
  const context = useForeContext();

  const handleLinkClicked = (url: string, postback?: Postback) => {
    userActions.sendLinkClicked(context, url, postback);
  };

  const handleSendMessage = (text: string, postback?: Postback) => {
    userActions.sendMessageWithPostback(context, text, postback);
  };

  const renderButton = (button: Button) => {
    switch (button.type) {
      case "TEXT": {
        return (
          <TextButtonContent
            key={button.displayText}
            button={button}
            buttonsStyle={buttonsStyle}
            onSendMessage={handleSendMessage}
            disabled={disableTextButtons}
          />
        );
      }
      case "URL":
        return (
          <UrlButtonContent
            key={button.displayText}
            button={button}
            buttonsStyle={buttonsStyle}
            onLinkClicked={handleLinkClicked}
          />
        );
      default:
        assertUnreachable(button);
        return undefined;
    }
  };

  return <div className={style[buttonsStyle]}>{buttons.map((button) => renderButton(button))}</div>;
};
